// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"admin-portal__util__errorMessage","spinnerContainer":"admin-portal__util__spinnerContainer"};